export const FSC_COMPLIANCE_TYPE_ID = 1;

export interface ComplianceCertificateDTO {
    id: number;
    certificateCode?: string;
    certificateName: string;
    issuingAuthority?: string;
    issueDate?: string;
    expiryDate?: string;
    remarks?: string;
    status?: string;
}

export interface ComplianceTypeWithCertificatesDTO {
    complianceTypeId: number;
    typeCode: string;
    typeName: string;
    typeStatus?: string;
    certificates: ComplianceCertificateDTO[];
}

export interface ComplianceCertificateFindDTO {
    id: number;
    compliance_type_id: number;
    type_code?: string;
    type_name?: string;
    certificate_code?: string;
    certificate_name: string;
    issuing_authority?: string;
    issue_date?: string;
    expiry_date?: string;
    remarks?: string;
    status?: string;
}

export interface ComplianceCertificateFindParams {
    type_name?: string;
    type_code?: string;
    certificate_code?: string;
    certificate_name?: string;
    status?: string;
    cursor?: number;
    limit?: number;
}

export interface ComplianceCertificateItemPayload {
    certificateCode?: string;
    certificateName: string;
    issuingAuthority?: string;
    issueDate?: string;
    expiryDate?: string;
    remarks?: string;
}

export interface CreateComplianceCertificatePayload {
    complianceTypeId?: number;
    typeCode?: string;
    typeName?: string;
    certificates: ComplianceCertificateItemPayload[];
    addedBy: string;
}

export interface UpdateComplianceCertificatePayload {
    complianceTypeId?: number;
    typeCode?: string;
    typeName?: string;
    certificateCode?: string;
    certificateName: string;
    issuingAuthority?: string;
    issueDate?: string;
    expiryDate?: string;
    remarks?: string;
    updatedBy: string;
}

export interface ComplianceTypeOption {
    complianceTypeId: number;
    typeCode: string;
    typeName: string;
}
